import {AbstractControl, ValidatorFn} from '@angular/forms';

import {LatinDigitsFullStopValidatorKey} from './custom-validator-keys';

export function LatinDigitsFullStopValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[a-zA-Z0-9\s.]+$/.test(controlValue) ? {[LatinDigitsFullStopValidatorKey]: true} : null;
    };
}
